
/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {FetchOptions} from 'ofetch';
import type {
  CompanyIdentityCapabilitiesResource,
  CompanyIdentityResource,
  CompanyIdentitySearchResultResource,
  CreateCompanyIdentityRequest,
  ValidationError,
} from '../models';
import {
    CompanyIdentityCapabilitiesResourceFromJSON,
    CompanyIdentityCapabilitiesResourceToJSON,
    CompanyIdentityResourceFromJSON,
    CompanyIdentityResourceToJSON,
    CompanyIdentitySearchResultResourceFromJSON,
    CompanyIdentitySearchResultResourceToJSON,
    CreateCompanyIdentityRequestFromJSON,
    CreateCompanyIdentityRequestToJSON,
    ValidationErrorFromJSON,
    ValidationErrorToJSON,
} from '../models';

export interface CreateCompanyIdentityOperationRequest {
    createCompanyIdentityRequest: CreateCompanyIdentityRequest;
}

export interface SearchCompanyIdentitiesRequest {
    searchText?: string;
    countryCode?: string;
    primaryRegistrationNumberType?: string;
    page?: number;
    size?: number;
}

/**
 * 
 */
export class CompanyIdentityAdminApi extends runtime.BaseAPI {

    /**
     * Creates a CompanyIdentity from a primary legal identifier, an optional set of additional legal identifiers (which must share the primary\'s countryCode), and an optional VAT number. 
     * Create a new company identity (admin endpoint)
          */
    async createCompanyIdentityRaw(requestParameters: CreateCompanyIdentityOperationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<CompanyIdentityResource>> {
        if (requestParameters['createCompanyIdentityRequest'] == null) {
            throw new runtime.RequiredError(
                'createCompanyIdentityRequest',
                'Required parameter "createCompanyIdentityRequest" was null or undefined when calling createCompanyIdentity().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<CompanyIdentityResource>({
            path: `/compliance/api/admin/company-identities`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateCompanyIdentityRequestToJSON(requestParameters['createCompanyIdentityRequest']),
        }, initOverrides);

        if (response._data) { response._data=CompanyIdentityResourceFromJSON(response._data); }
        return response;
    }

    /**
     * Creates a CompanyIdentity from a primary legal identifier, an optional set of additional legal identifiers (which must share the primary\'s countryCode), and an optional VAT number. 
     * Create a new company identity (admin endpoint)
          */
    async createCompanyIdentity(requestParameters: CreateCompanyIdentityOperationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<CompanyIdentityResource> {
        const response = await this.createCompanyIdentityRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
     * Returns the static metadata used to populate the UI country and registration-number-type pickers (search filters in this feature, create form in feature 2). Derived from `com.malt.validation.company.CountryCode.registrationNumberMatchers`. 
     * Get supported countries and identifier types (admin endpoint)
          */
    async getCompanyIdentityCapabilitiesRaw(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<CompanyIdentityCapabilitiesResource>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<CompanyIdentityCapabilitiesResource>({
            path: `/compliance/api/admin/company-identities/capabilities`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=CompanyIdentityCapabilitiesResourceFromJSON(response._data); }
        return response;
    }

    /**
     * Returns the static metadata used to populate the UI country and registration-number-type pickers (search filters in this feature, create form in feature 2). Derived from `com.malt.validation.company.CountryCode.registrationNumberMatchers`. 
     * Get supported countries and identifier types (admin endpoint)
          */
    async getCompanyIdentityCapabilities(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<CompanyIdentityCapabilitiesResource> {
        const response = await this.getCompanyIdentityCapabilitiesRaw(initOverrides);
        return response._data;
    }

    /**
     * Returns a paginated list of CompanyIdentity aggregates. The `searchText` parameter performs a case-insensitive infix match against the registration number value of any contained legal identifier, and against the VAT number value. Whitespace is stripped before matching. `countryCode` and `primaryRegistrationNumberType` are exposed as table column filters in the UI. The combined filter is AND across all provided params. 
     * Search company identities (admin endpoint)
          */
    async searchCompanyIdentitiesRaw(requestParameters: SearchCompanyIdentitiesRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<CompanyIdentitySearchResultResource>> {
        const queryParameters: any = {};

        if (requestParameters['searchText'] != null) {
            queryParameters['searchText'] = requestParameters['searchText'];
        }

        if (requestParameters['countryCode'] != null) {
            queryParameters['countryCode'] = requestParameters['countryCode'];
        }

        if (requestParameters['primaryRegistrationNumberType'] != null) {
            queryParameters['primaryRegistrationNumberType'] = requestParameters['primaryRegistrationNumberType'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['size'] != null) {
            queryParameters['size'] = requestParameters['size'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<CompanyIdentitySearchResultResource>({
            path: `/compliance/api/admin/company-identities`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=CompanyIdentitySearchResultResourceFromJSON(response._data); }
        return response;
    }

    /**
     * Returns a paginated list of CompanyIdentity aggregates. The `searchText` parameter performs a case-insensitive infix match against the registration number value of any contained legal identifier, and against the VAT number value. Whitespace is stripped before matching. `countryCode` and `primaryRegistrationNumberType` are exposed as table column filters in the UI. The combined filter is AND across all provided params. 
     * Search company identities (admin endpoint)
          */
    async searchCompanyIdentities(requestParameters: SearchCompanyIdentitiesRequest = {}, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<CompanyIdentitySearchResultResource> {
        const response = await this.searchCompanyIdentitiesRaw(requestParameters, initOverrides);
        return response._data;
    }

}
